/* eslint-disable react/prop-types */
import React from 'react';
import teaser0 from '../../assets/images/video-screencap.jpg';
import teaser1 from '../../assets/images/comments-teaser.jpg';
import teaser2 from '../../assets/images/event-teaser.jpg';

import '~styles/modules/teasers.scss';

const Teasers = ({ relatedlinks }) => {
  const altText = [
    'Kate Price stands in front of a rest stop. Trucks are blurred in the background',
    'Kate Price stands in front of her childhood home.',
    'Kate Price’s face is reflected in a rear-view mirror as she drives down the highway. A large truck that reads "Everything handled with care" on the side passes her.',
  ];
  const list = relatedlinks.map((teaser, index) => {
    let image = '';
    const alt = altText[index];
    if (index === 0) {
      image = teaser0;
    } else if (index === 1) {
      image = teaser1;
    } else if (index === 2) {
      image = teaser2;
    }
    return (
      <li className="teasers__item" key={teaser.url}>
        <a className="teasers__link" href={teaser.url} target="_blank" rel="noreferrer">
          <div className="teasers__image-container">
            <img
              className="teasers__image"
              src={image}
              alt={alt}
            />
          </div>
          <h3 className="teasers__hed miller-n6">{index === 0 ? 'Video: ' : null}{teaser.headlines.basic}</h3>
        </a>
      </li>
    );
  });

  return (
    <div className="teasers">
      <h4 className="teasers__title benton-n6">Up next</h4>
      <ul className="teasers__list">
        {list}
      </ul>
    </div>
  );
};

export default Teasers;
